<template>
  <b-container fluid class="px-0">
    
    <div class="d-flex">  
      <b-form-group
        label-for="filter-input"
        class="w-100 mr-3"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <div class="ml-auto">
        <b-btn variant="dark" class="border-white btn-sm ml-auto" v-b-tooltip.hover title="Reports"  @click.prevent="downloadExcel()">
            <font-awesome-icon :icon="['fas', 'file-excel']" class="text-white"/>
          </b-btn>
        </div>
    </div>
    <b-table class="col-12" :items="groupedSections" :fields="fields" :filter="filter" >
      <template  #cell(label)="row">
        <a href='javascript://'
          v-b-tooltip.hover.right="'click to see equipments'"
          @click="row.toggleDetails"
          v-if="Object.keys(row.item.equipment_categories || {}).length > 0"
        >
          <font-awesome-icon :icon="['fas', 'caret-down']" v-if="row.detailsShowing"/>
          <font-awesome-icon :icon="['fas', 'caret-right']" v-else/>
          {{ row.item.label || "No Label" }}
        </a>
        <a v-else>
          {{ row.item.label || "No Label" }}
        </a>
      </template>
      <template #cell(perimeter)="row">
        {{row.value | round}} M
      </template>
      <template #cell(area)="row">
        {{row.value | round}} <span v-if="row.value">M<sup>2</sup></span>
      </template>
      <template #cell(net_area)="row">
        {{ row.value | round }} <span v-if="row.value">M<sup>2</sup></span>
      </template>
      <template #cell(equip_count)="row">
        {{(Object.values(row.item.equipment_categories || {})).flat().length}}
      </template>
      <template #cell(action)="row">
        <div>
          <span style="cursor:pointer"
            v-b-tooltip.hover.right="'click to locate'"
            @click="locateSection(row.item.id)"
            class="mr-2"
          >
            <font-awesome-icon color="royalblue" icon="search" />
          </span>
          <a href="javascript://" @click="editSection(row.item.id)">
            <font-awesome-icon icon="pencil" size="sm" class="mr-2 text-dark" />
          </a>
          <a href="javascript://" @click="deleteSection(row.item)">
            <font-awesome-icon icon="trash" size="sm" class="text-danger"/>
          </a>
        </div>
      </template>

      <template #row-details="row">
        <b-table :items="getEquipmentConfig(row.item.equipment_categories)" :fields="equipmentConfigFields" thead-class="d-none">
          <template #cell(name)="configRow">
            <div class="d-flex">  
              <div class="w-25">
                <a href='javascript://' @click="configRow.toggleDetails">
                  <font-awesome-icon :icon="['fas', 'caret-down']" v-if="configRow.detailsShowing"/>
                  <font-awesome-icon :icon="['fas', 'caret-right']" v-else/>
                  {{$t("equipment_type." + (((row.item.equipment_categories[configRow.item.id][0] || {}).equipment_detail || {}).equipment_config || {}).name)}}
                </a>
              </div>
              <small class="ml-2" v-if="['polygon', 'polyline'].includes(row.item.equipment_categories[configRow.item.id][0].shape_type)">
                <i>  
                  <strong>{{ $t("sidebar.label.total_perimeter") }}: </strong> 
                   {{totalLength(row.item.equipment_categories[configRow.item.id]) | round}}M
                </i>
              </small>
              <small class="ml-2" v-if="['polygon'].includes(row.item.equipment_categories[configRow.item.id][0].shape_type)">
                <i>  
                  <strong>Area: </strong> 
                   {{totalArea(row.item.equipment_categories[configRow.item.id]) | round}}M<sup> 2 </sup>
                </i>
              </small>
              <small class="ml-2">
                <i>
                  <strong>Count: </strong> 
                   {{row.item.equipment_categories[configRow.item.id].length}}
                </i>
              </small>
              <div class="ml-auto">
                <b-dropdown size="lg"  variant="link btn-sm" toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <font-awesome-icon :icon="['fas', 'ellipsis-vertical']" />
                  </template>
                  <b-dropdown-item href="#" @click="openMultiEquipmentForm(row.item, configRow.item)">Edit</b-dropdown-item>
                  <b-dropdown-item href="#" @click="bulkDeleteSections()">
                    <span class="text-danger">  
                      Delete
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>

          <template #row-details="configRow">
            <b-table :items="row.item.equipment_categories[configRow.item.id]" :fields="equipmentFields" class="ml-3" >
              <template #cell(label)="equipmentDetail">
                <b-form-checkbox
                  v-model="selectedEquipments"
                  :value="equipmentDetail.item"
                  unchecked-value="not_accepted"
                  @change="onEquipmentSelected(equipmentDetail.item)"
                >
                  {{equipmentDetail.item.label || 'No label'}}
                </b-form-checkbox>

              </template>

              <template #head(select_all)="equipmentDetail">
                <b-form-checkbox
                  v-model="selectAllForRoof"
                  :value="row.item.id + '_' + configRow.item.id"
                  unchecked-value=""
                  @change="onSelectAllForRoofChange(configRow.item)"
                >
                </b-form-checkbox>
              </template>

              <template #cell(perimeter)="equipmentDetail">
                {{equipmentDetail.value | round}} <span v-if="equipmentDetail.value"> M </span>
              </template>
              <template #cell(area)="equipmentDetail">
                {{equipmentDetail.value | round}} <span v-if="equipmentDetail.value">M<sup>2</sup></span>
              </template>

              <template #cell(action)="equipmentDetail">
                <div>
                  <span style="cursor:pointer"
                    v-b-tooltip.hover.right="'click to locate'"
                    @click="locateSection(equipmentDetail.item.id)"
                    class="mr-2"
                  >
                    <font-awesome-icon color="royalblue" icon="search" />
                  </span>
                  <a href="javascript://" @click="editSection(equipmentDetail.item.id)">
                    <font-awesome-icon icon="pencil" size="sm" class="mr-2 text-dark" />
                  </a>
                  <a href="javascript://" @click="deleteSection(equipmentDetail.item)">
                    <font-awesome-icon icon="trash" size="sm" class="text-danger"/>
                  </a>
                </div>
              </template>
            </b-table>
          </template>
        </b-table>
      </template>
    </b-table>
    <div class="text-center">
      <h5>
        Equipments without roof sections
      </h5>
    </div>

    <div class="col-12 pl-0">
      <b-table :items="getEquipmentConfig(equipmentsWithoutRoof)" :fields="equipmentConfigFields" thead-class="d-none">
          <template #cell(name)="configRow">
            <div class="d-flex">  
              <div class="w-25">
                <a href='javascript://' @click="() => {
                  configRow.toggleDetails()
                  selectAllForRoof = ''
                  parentRowSelected = {}
                  selectedEquipments = []
                  }">
                  <font-awesome-icon :icon="['fas', 'caret-down']" v-if="configRow.detailsShowing"/>
                  <font-awesome-icon :icon="['fas', 'caret-right']" v-else/>
                  {{$t("equipment_type." + (((equipmentsWithoutRoof[configRow.item.id][0] || {}).equipment_detail || {}).equipment_config || {}).name)}}
                </a>
              </div>
              <small class="ml-2" v-if="['polygon', 'polyline'].includes(equipmentsWithoutRoof[configRow.item.id][0].shape_type)">
                <i>  
                  <strong>{{ $t("sidebar.label.total_perimeter") }}: </strong> 
                   {{totalLength(equipmentsWithoutRoof[configRow.item.id]) | round}}M
                </i>
              </small>
              <small class="ml-2" v-if="['polygon'].includes(equipmentsWithoutRoof[configRow.item.id][0].shape_type)">
                <i>  
                  <strong>Area: </strong> 
                   {{totalArea(equipmentsWithoutRoof[configRow.item.id]) | round}}M<sup> 2 </sup>
                </i>
              </small>
              <small class="ml-2">
                <i>
                  <strong>Count: </strong> 
                   {{equipmentsWithoutRoof[configRow.item.id].length}}
                </i>
              </small>
              <div class="ml-auto">
                <b-dropdown size="lg"  variant="link btn-sm" toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <font-awesome-icon :icon="['fas', 'ellipsis-vertical']" />
                  </template>
                  <b-dropdown-item href="#" @click="openMultiEquipmentNonSectionForm({}, configRow.item)">Edit</b-dropdown-item>
                  <b-dropdown-item href="#" @click="bulkDeleteSections()">
                    <span class="text-danger">  
                      Delete
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>

          <template #row-details="configRow">
            <b-table :items="equipmentsWithoutRoof[configRow.item.id]" :fields="equipmentFields" class="ml-3" >
              <template #cell(label)="equipmentDetail">
                <b-form-checkbox
                  v-model="selectedEquipments"
                  :value="equipmentDetail.item"
                  unchecked-value="not_accepted"
                  @change="onEquipmentSelected(equipmentDetail.item)"
                >
                  {{equipmentDetail.item.label || 'No label'}}
                </b-form-checkbox>

              </template>

              <template #head(select_all)="">
                <b-form-checkbox
                  :checked="isParentRowSelected(configRow.item.id)"
                  @change="selectAllEquipment(configRow.item.id)"
                >
                </b-form-checkbox>
              </template>

              <template #cell(perimeter)="equipmentDetail">
                {{equipmentDetail.value | round}} <span v-if="equipmentDetail.value"> M </span>
              </template>
              <template #cell(area)="equipmentDetail">
                {{equipmentDetail.value | round}} <span v-if="equipmentDetail.value">M<sup>2</sup></span>
              </template>

              <template #cell(action)="equipmentDetail">
                <div>
                  <span style="cursor:pointer"
                    v-b-tooltip.hover.right="'click to locate'"
                    @click="locateSection(equipmentDetail.item.id)"
                    class="mr-2"
                  >
                    <font-awesome-icon color="royalblue" icon="search" />
                  </span>
                  <a href="javascript://" @click="editSection(equipmentDetail.item.id)">
                    <font-awesome-icon icon="pencil" size="sm" class="mr-2 text-dark" />
                  </a>
                  <a href="javascript://" @click="deleteSection(equipmentDetail.item)">
                    <font-awesome-icon icon="trash" size="sm" class="text-danger"/>
                  </a>
                </div>
              </template>
            </b-table>
          </template>
        </b-table>
    </div>
  </b-container>

</template>

<script>
  import { mapGetters } from 'vuex';
  import appConfig from '@/config/app.config'
  export default {
      name: "SectionsListDrawer",
      data: () => ({
        filter: null,
        equipmentConfigFields: [{
          key: 'name'
        }],

        selectedEquipments: [],
        parentRowSelected: {},
        withoutRoofEquipments: null,
        selectAllForRoof: ''
      }),

      beforeDestroy(){
        this.allShapes.map(sh => sh.setOptions({fillColor: "#FFFFFF", fillOpacity: 0}))
      },
      computed: {
        ...mapGetters({
          sections: 'sections/items'
        }),
        ...mapGetters({
            sections: 'sections/items',
            allShapes: 'gmap/allShapes',
            map: 'gmap/map',
        }),

        roofSections: function(){
          return this.sections.filter(s => s.section_type == 'roof').map(roof=>{
            roof.equip_count = this.sections.filter((s)=>{
              return s.equipment_detail && s.equipment_detail.roof_section_id == roof.id
            }).length
            return roof
          })
        },

        fields(){
          return [
            { key: 'label', label: this.$t("sidebar.heading.label"), sortable: true },
            { key: 'perimeter', label: this.$t("sidebar.heading.perimeter"), sortable: true },
            { key: 'area', label: this.$t("sidebar.heading.area"), sortable: true },
            { key: 'net_area', label: this.$t("sidebar.heading.net_area"), sortable: true },
            {
              key: 'equip_count',
              label: this.$t("sidebar.heading.equip_count"),
              sortable: true,
              thStyle: { width: '60px', textAlign: 'center' },
              tdClass: 'text-center'
            },
            {
              key: 'action',
              label: this.$t("sidebar.heading.action"),
              sortable: false,
              thStyle: { width: '120px', textAlign: 'center' },
              tdClass: 'text-center'
            }
          ]
        },

        equipmentFields(){
          return [
            { key: 'select_all', label: "" },
            { key: 'label', label: this.$t("sidebar.heading.label"), sortable: true },
            { key: 'perimeter', label: this.$t("sidebar.heading.perimeter"), sortable: true },
            { key: 'area', label: this.$t("sidebar.heading.area"), sortable: true },
            { key: 'action', label: this.$t("sidebar.heading.action"), sortable: false }
          ]
        },

        equipmentsWithoutRoof(){
          const equipments = this.sections.filter(s => s.section_type == 'equipment' && (s.equipment_detail || {}).roof_section_id == null)

          const equipmentByCategory = equipments.reduce((acc, equipment) => {
              const equipmentConfig = (equipment.equipment_detail || {}).equipment_config
              const category = equipmentConfig.id
              if (!acc[category]) {
                  acc[category] = [];
              }
              acc[category].push(equipment);
              return acc;
          }, {});

          this.withoutRoofEquipments = equipmentByCategory

          return equipmentByCategory
        },

        groupedSections(){
          const roofs = this.sections.filter(item => item.section_type === 'roof');
          const grouped = roofs.map(roof => {

              // Find equipment belonging to this 'roof'
              const equipments = this.sections.filter(equipment => equipment.section_type === 'equipment' && (equipment.equipment_detail || {}).roof_section_id === parseInt(roof.id));
              console.log(equipments)
              // Group equipment by 'equipment_category'
              const equipmentByCategory = equipments.reduce((acc, equipment) => {
                  const equipmentConfig = (equipment.equipment_detail || {}).equipment_config
                  const category = equipmentConfig.id
                  if (!acc[category]) {
                      acc[category] = [];
                  }
                  acc[category].push(equipment);
                  return acc;
              }, {});

              return {
                  ...roof,
                  equipment_categories: equipmentByCategory
              };
          });

          return grouped
        },

        isParentRowSelected() {
          return (rowId) => {
            const allSelected = this.withoutRoofEquipments[rowId].every(equipment => 
              this.selectedEquipments.includes(equipment)
            );
            return allSelected ? true : false;
          };
        }
      },

      methods: {
        editSection(sectionId){
          this.$store.dispatch('sections/selectItem', sectionId)
          this.$store.dispatch('ui/projectSidebar.open', {
            show: true,
            component: 'SectionInfoDrawer',
            heading: 'Roof info',
            align: 'right',
            right: true,
            noHeader: true,
            key: `section-${sectionId}`
          })
        },

        deleteSection(section){
          if(confirm("Are you sure to delete Equipment?")){
            this.$store.dispatch("sections/delete", {
              projectId: section.project_id,
              id: section.id
            })
          }
        },

        locateSection(sectionId){
          if(this.$store.getters['projects/item'].asset_type == 'drone'){
            this.editSection(sectionId)
          } else {
            this.$eventbus.$emit('locate', sectionId)
          }
        },

        getEquipmentConfig(equipmentCategories){
          return Object.keys(equipmentCategories).map(id => {return {id: id}})
        },

        totalLength(equipments){
          const sum = equipments.reduce((accumulator, currentValue) => {
              return accumulator + currentValue.perimeter;
          }, 0);
          return sum
        },

        onEquipmentSelected(equipment){
          this.selectAllForRoof = ''
          this.resetEquipmentColor()
        },

        resetEquipmentColor(){
          const selectedShapes = this.allShapes.filter(sh => (this.selectedEquipments.map(e => e.id)).includes(sh.id))
          this.allShapes.map(sh => sh.setOptions({fillColor: "#FFFFFF", fillOpacity: 0}))
          selectedShapes.map(sh => sh.setOptions({fillColor: "#FF0000", fillOpacity: 0.6}))
        },

        totalArea(equipments){
          const sum = equipments.reduce((accumulator, currentValue) => {
              return accumulator + currentValue.area;
          }, 0);
          return sum
        },
        async downloadExcel(){
          const projectId = this.$route.params.id
          await this.$store.dispatch('session/refresh')
          const token = this.$store.getters['session/currentToken']
          const url = `${appConfig.API_BASE_URL}/projects/${projectId}/sections/export?token=${token}`
          window.location.href = url
        },

        openMultiEquipmentForm(section, equipmentConfig){
          const selectedSectionEquipments = this.selectedEquipments.filter(eq => (eq.equipment_detail || {}).roof_section_id == section.id && parseInt(equipmentConfig.id) == (eq.equipment_detail || {}).equipment_config_id)
          console.log(selectedSectionEquipments.length)
          this.$store.dispatch('ui/modal', {
              show: true,
              size: "lg",
              component: 'multi-equipment-edit-modal',
              data: {roofSection: section, equipments: selectedSectionEquipments, equipmentConfig: equipmentConfig}
          })
        },

        openMultiEquipmentNonSectionForm(section, equipmentConfig){
          const selectedSectionEquipments = this.selectedEquipments.filter(eq => (eq.equipment_detail || {}).roof_section_id == section.id && parseInt(equipmentConfig.id) == (eq.equipment_detail || {}).equipment_config_id)
          console.log(selectedSectionEquipments.length)
          this.$store.dispatch('ui/modal', {
              show: true,
              size: "lg",
              component: 'multi-equipment-edit-modal',
              data: {roofSection: section, equipments: selectedSectionEquipments, equipmentConfig: equipmentConfig}
          })
        },

        selectAllEquipment(withoutRoofEquipmentId) {
          this.selectAllForRoof = ''
          const isSelected = this.parentRowSelected[withoutRoofEquipmentId] || false;
          
          if (!isSelected) {
            this.selectedEquipments = this.withoutRoofEquipments[withoutRoofEquipmentId].map(
                equipment => equipment
              );
            this.parentRowSelected[withoutRoofEquipmentId] = true;
          } else {
            this.selectedEquipments = []
            this.parentRowSelected[withoutRoofEquipmentId] = false;
          }
          this.resetEquipmentColor()
        },

        isEquipmentSelected(equipment) {
          return this.selectedEquipments.some(selected => selected.id === equipment.id);
        },

        onSelectAllForRoofChange(equipmentConfig) {
          let roofSectionId = this.selectAllForRoof.split('_')[0]
          let section = this.groupedSections.filter(x => x.id == roofSectionId)[0]
          if(section){
            let equipments = section.equipment_categories[equipmentConfig.id]
            this.selectedEquipments = equipments
          } else {
            this.selectedEquipments = []
          }
          this.resetEquipmentColor()
        },

        bulkDeleteSections() {
          if (confirm("Are you sure you want to delete the selected equipments?")) {
            const projectId = this.$route.params.id
            const equipmentIds = this.selectedEquipments.map(eq => eq.id)
            this.$store.dispatch('sections/bulkDeleteSections', {projectId: projectId, sectionIds: equipmentIds});
          }
        }

      }
  }
</script>
